import { combineReducers } from '@reduxjs/toolkit';
import settings from './settingsSlice';
import dialog from './dialogSlice';
import menu from './menuSlice';
import message from './messageSlice';

const core = combineReducers({
  settings,
  menu,
  dialog,
  message,
});

export default core;
